// extracted by mini-css-extract-plugin
export default {"shadowed":"App_shadowed__BC3oN","dark":"App_dark__sU4Z9","light":"App_light__8Fl1g"};